/* eslint-disable @typescript-eslint/no-explicit-any */

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Group } from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Styles
import styles from './CellTags.module.css';

import { Pill } from '@components/atoms/Pill';
import { NOT_APPLICABLE } from '@config/constants/common';

export type Tag = {
	id: string;
	color: string;
	value: {
		en?: string;
		fr?: string;
	};
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellTags = (props: { tags: Tag[] }) => {
	const { i18n } = useTranslation();
	const { tags } = props;

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={styles.cell}>
			<Group gap={'5px'}>
				{Array.isArray(tags) &&
					tags?.map((tag: any) => (
						<div key={tag.id}>
							<Pill
								color={tag.color}
								text={
									i18n && i18n.language == 'en'
										? tag?.value?.en || NOT_APPLICABLE
										: tag?.value?.fr || NOT_APPLICABLE
								}
							/>
						</div>
					))}
			</Group>
		</Box>
	);
};
